import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';
//https://s-yadav.github.io/react-number-format/docs/numeric_format/
import NumberFormat from 'react-number-format';
import Person from "../Person";

export default class Salary extends Base {
	constructor(props) {
		super(props);
		this.state = {
			refreshCallerAfterSave: this.isNull(props.RefreshCallerAfterSave) ? true : props.RefreshCallerAfterSave,
			caller: props.Caller,
			controllerName: 'salary',
			id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
			data: null,
			loading: true,
			sourceId: this.isNull(props.SourceId) ? 0 : props.SourceId,
			type: props.Type,
			initPerson: this.isNull(props.InitPerson) ? null : props.InitPerson,
			rowIdSelectedToUpload: null
		};
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	componentDidMount() {
		this.addKeyDown();
		this.httpPost("api/v1/salary/get", {
			id: this.state.id,
			type: this.state.type,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					window.organizationId = data.global.company.id;
					this.state.data = data;
					if (this.state.id === this.getDefaultGuid()) {
						if (!this.isNull(this.state.initPerson)) {
							this.state.data.record.personId = this.state.initPerson.id;
							this.state.data.record.personName = this.state.initPerson.name;
						}
					}
					this.state.loading = false;
					this.updateFormula();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	save(e, status) {
		e.preventDefault();

		var items = [];

		this.state.data.record.items.forEach((i) => {
			var clone = Object.assign({}, i);
			clone.date = this.convertMomentToDb(clone.date);
			items.push(clone);
		});

		if (this.isBlank(this.state.data.record.number)) this.state.data.record.number = 0;

		this.httpPost("api/v1/salary/save", {
			id: this.state.id,
			organizationId: this.state.data.global.company.id,
			personId: this.state.data.record.personId,
			fromDate: this.convertMomentToDb(this.state.data.record.fromDate),
			toDate: this.convertMomentToDb(this.state.data.record.toDate),
			items: items,
			status: status
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
					if (this.state.refreshCallerAfterSave)
						this.state.caller.refreshData();
					this.closeMe();
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	removeDocument() {
		this.httpPost('api/v1/salary/removedocument', {
			id: this.state.data.record.id,
			organizationId: this.state.data.global.company.id,
		}).then((data) => {
			if (data.status === -1) window.location.href = '/login';
			if (data.status === 1) {
				this.showSuccessMessage('سند با موفقیت حذف شد');
				if (this.state.refreshCallerAfterSave) this.state.caller.refreshData();
				this.closeMe();
			} else {
				this.showErorrMessage(data.message);
				this.setState({
					loading: false,
				});
			}
		});
	}
	getBlankRow(defaultIndex = null) {
		return {
			id: this.uuidv4(),
			order: (defaultIndex == null ? this.state.data.record.items.length + 1 : defaultIndex),
			description: '',
			accountId: this.defaultGuid(),
			accountTitle: '',
			personId: this.defaultGuid(),
			personName: '',
			price: 0,
			attachment: '',
			factorNo: '',
			date: null,
		};
	}
	addBlankRow() {
		this.state.data.record.items.push(this.getBlankRow());
	}
	removeRow(id) {
		var temp = [];
		var index = 1;
		this.state.data.record.items.sort((a, b) => a.order - b.order).forEach(r => {
			if (r.id != id) {
				temp.push(r);
				temp[temp.length - 1].order = index;
				index++;
			}
		});
		this.state.data.record.items = temp;
		this.updateFormula();
	}
	copyRow(id) {
		var clone = null;
		this.state.data.record.items.forEach(i => {
			if (i.id === id) {
				clone = Object.assign({}, i);
			}
		});
		clone.id = this.uuidv4();
		var startIndex = clone.order;
		for (var i = 0; i < this.state.data.record.items.length; i++) {
			if (this.state.data.record.items[i].order > startIndex) this.state.data.record.items[i].order++;
		}
		clone.order++;
		this.state.data.record.items.push(clone);
		this.updateFormula();
	}
	upIndex(id) {
		var idIndex = -1;
		this.state.data.record.items.forEach((r, index) => {
			if (r.id == id) idIndex = index;
		});
		if (idIndex != -1 && idIndex > 0) {
			var ii = this.state.data.record.items[idIndex].order;
			this.state.data.record.items[idIndex].order = ii - 1;
			this.state.data.record.items[idIndex - 1].order = ii;
			this.setState({ data: this.state.data });
		}
	}
	downIndex(id) {
		var idIndex = -1;
		this.state.data.record.items.forEach((r, index) => {
			if (r.id == id) idIndex = index;
		});
		if (idIndex != -1 && idIndex < this.state.data.record.items.length - 1) {
			var ii = this.state.data.record.items[idIndex].order;
			this.state.data.record.items[idIndex].order = ii + 1;
			this.state.data.record.items[idIndex + 1].order = ii;
			this.setState({ data: this.state.data });
		}
	}
	setBodyValue(id, field, value) {
		for (var i = 0; i < this.state.data.record.items.length; i++) {
			if (this.state.data.record.items[i].id === id) {
				if (field == 'accountId' || field == 'personId') {
					if (field == 'accountId') {
						this.state.data.record.items[i][field] = value.value;
						this.state.data.record.items[i]["accountTitle"] = value.label;
					}
					if (field == 'personId') {
						this.state.data.record.items[i][field] = value.value;
						this.state.data.record.items[i]["personName"] = value.label;
					}
				}
				else {
					this.state.data.record.items[i][field] = value;
				}
			}
		}
		this.updateFormula();
	}
	updateFormula() {
		var total = 0;
		var hasBlankRow = false;

		for (var i = 0; i < this.state.data.record.items.length; i++) {
			if (this.state.data.record.items[i].accountId == this.defaultGuid()) hasBlankRow = true;
			total += this.state.data.record.items[i]['price'];
		}

		this.state.data.record.total = total;

		if (!hasBlankRow) this.addBlankRow();

		this.setState({ date: this.state.data });
	}
	setPerson(e) {
		if (e.value == -1) {
			this.state.data.record.personId = this.defaultGuid();
			this.state.data.record.personName = '';
			this.showComponents({ component: <Person Caller={this} FromAutoComplete={true} /> });
			return;
		}
		this.state.data.record.personId = e.value;
		this.state.data.record.personName = e.label;
		this.setState({ data: this.state.data });
	}
	pickAttachmentFile(id) {
		this.state.rowIdSelectedToUpload = id;
		document.getElementById('attachFilePicker').click();
	}
	uploadAttachment(_file) {
		var id = this.state.rowIdSelectedToUpload;
		if (this.isNull(id)) return;

		var th = this;
		this.lockScreen();
		this.getBase64(_file).then(file => {
			var pic = file;
			var picFileName = _file.name;

			th.httpPost("api/v1/salary/upload", {
				pic,
				picFileName,
			})
				.then(data => {
					if (data.status === -1) window.location.href = "/login";
					if (data.status === 1) {
						th.setBodyValue(id, 'attachment', data.fileName);
					}
					else {
						th.showErorrMessage(data.message);
					}
					th.setState({
						rowIdSelectedToUpload: null,
						loading: false
					});
				});
		});
	}
	renderForm() {
		return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
			<input id="attachFilePicker" type="file" className="hidden" onChange={(e) => { this.uploadAttachment(e.target.files[0]) }} />
			<div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
			<div className="modal-dialog ui-draggable" style={{ "width": "96%", "left": "7.125px", "top": "-2px" }}>
				<div className="modal-content">
					<div className="modal-body">
						<div className="modal-header modal-header-info" style={{ "padding": "0" }}>
							<button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
							<h4 className="modal-title">تنخواه</h4>
						</div>
						<div className="modal-body" style={{ "display": "flex", "flex-direction": "column", "gap": "10px" }}>
							<div className="row">
								<div className="col-sm-3">
									<div className="form-group">
										<label for="invoiceContact" className="title1">تنخواه گردان<span className="red">*</span></label>
										<SelectAsync
											value={this.state.data.record.personId != this.defaultGuid() ? [{ value: this.state.data.record.personId, label: this.state.data.record.personName }] : null}
											isMulti={false}
											placeholder="انتخاب تنخواه گردان"
											defaultOptions
											loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback, 1, 4)}
											onChange={e => this.setPerson(e)}
										/>
									</div>
								</div>
								<div className="col-sm-2">
									<div className="form-group">
										<label for="invoiceDate" className="title1">از تاریخ<span className="red">*</span></label>
										<DatePicker
											inputReadOnly={true}
											className="form-control input-sm persian-date"
											placeholder={"از تاریخ"}
											isGregorian={false}
											showTodayButton={true}
											timePicker={false}
											onChange={(e) => { this.state.data.record.fromDate = e }}
											value={this.getFormatedDateForDatePicker(this.state.data.record.fromDate)}
										/>
									</div>
								</div>
								<div className="col-sm-2">
									<div className="form-group">
										<label for="invoiceDate" className="title1">تا تاریخ<span className="red">*</span></label>
										<DatePicker
											inputReadOnly={true}
											className="form-control input-sm persian-date"
											placeholder={"تا تاریخ"}
											isGregorian={false}
											showTodayButton={true}
											timePicker={false}
											onChange={(e) => { this.state.data.record.toDate = e }}
											value={this.getFormatedDateForDatePicker(this.state.data.record.toDate)}
										/>
									</div>
								</div>
								{this.state.data.record.id !== this.getDefaultGuid() && <div className="col-sm-2">
									<div className="form-group">
										<label for="invoiceNumber" className="title1">شماره</label>
										<input defaultValue={this.state.data.record.number} onChange={e => this.state.data.record.number = parseInt(e.target.value)} disabled="disabled" autocomplete="off" type="text" className="form-control input-smnumber" maxlength="20" />
									</div>
								</div>}
							</div>
							<table className="table table-bordered acc_grid_row">
								<thead>
									<tr className="active">
										<td style={{ "width": "30px" }}>#</td>
										<td>مرکز هزینه<span className="red">*</span></td>
										<td style={{ "width": "80px" }}>شماره فاکتور</td>
										<td>شرح</td>
										<td style={{ "width": "100px" }}>مبلغ <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span><span className="red">*</span></td>
										<td style={{ "width": "80px" }}>تاریخ</td>
										<td>طرف حساب</td>
										<td style={{ "width": "75px" }}>پیوست</td>
										{this.state.data.record.status === 0 && <td style={{ "width": "35px" }}></td>}
									</tr>
								</thead>
								<tbody>
									{this.state.data.record.items.sort((a, b) => a.order - b.order).map((item, index) =>
										<tr key={item.id}>
											<td>
												<span className="inGridRowNumber">{(index + 1)}</span>
												<div style={{ "font-size": "9pt", "color": "silver" }}>
													{index > 0 && index != this.state.data.record.items.length - 1 && <span onClick={e => this.upIndex(item.id)} className="fa fa-arrow-up move-up" title="انتقال به بالا"></span>}
													{index < this.state.data.record.items.length - 2 && <span onClick={e => this.downIndex(item.id)} className="fa fa-arrow-down move-down" title="انتقال به پایین"></span>}
												</div>
											</td>
											<td>
												<SelectAsync
													defaultValue={item.accountId != this.defaultGuid() ? [{ value: item.accountId, label: item.accountTitle }] : null}
													isMulti={false}
													placeholder="انتخاب"
													components={{
														//DropdownIndicator: () => null,
														IndicatorSeparator: () => null,
													}}
													noOptionsMessage={({ inputValue }) =>
														inputValue ? "نتیجه‌ای یافت نشد" : null
													}
													defaultOptions={[]}
													loadOptions={(inputValue, callback) => this.loadAccountOptions(inputValue, callback, 4, null, [8, 9])}
													onChange={e => this.setBodyValue(item.id, 'accountId', e)}
												/>
											</td>
											<td>
												<input type="text" className="form-control text-center" defaultValue={item.factorNo} onChange={e => this.setBodyValue(item.id, 'factorNo', e.target.value)} />
											</td>
											<td>
												<input type="text" className="form-control text-center" defaultValue={item.description} onChange={e => this.setBodyValue(item.id, 'description', e.target.value)} />
											</td>
											<td><NumberFormat value={item.price} onChange={e => this.setBodyValue(item.id, 'price', parseInt(e.target.value.replace(/,/g, '')))} thousandSeparator={true} prefix={''} className='form-control text-center ltr' /></td>
											<td style={{ "width": "80px" }}>
												<DatePicker
													inputReadOnly={true}
													className="form-control persian-date"
													placeholder={"تاریخ"}
													isGregorian={false}
													showTodayButton={true}
													timePicker={false}
													onChange={(e) => { this.setBodyValue(item.id, 'date', e) }}
													value={this.getFormatedDateForDatePicker(item.date)}
												/>
											</td>
											<td>
												<SelectAsync
													defaultValue={item.personId != this.defaultGuid() ? [{ value: item.personId, label: item.personName }] : null}
													isMulti={false}
													placeholder="انتخاب"
													components={{
														//DropdownIndicator: () => null,
														IndicatorSeparator: () => null,
													}}
													noOptionsMessage={({ inputValue }) =>
														inputValue ? "نتیجه‌ای یافت نشد" : null
													}
													defaultOptions={[]}
													loadOptions={(inputValue, callback) => this.loadPersonsOptions(inputValue, callback)}
													onChange={e => this.setBodyValue(item.id, 'personId', e)}
												/>
											</td>
											<td>
												{!this.isBlank(item.attachment) &&
													<a href={"/api/v1/media/salary/attachment/view/?file=" + item.attachment} target="_blank" className="me-1 text-primary hand" style={{"display": "inline-block"}}>مشاهده</a>	
												}
												{this.state.data.record.status === 0 && <a className="text-success hand" onClick={e => this.pickAttachmentFile(item.id)} style={{ "display": "inline-block" }}>درج</a>}
											</td>
											{this.state.data.record.status === 0 && <td>
												{item.stuffId != this.defaultGuid() && <span title="حذف سطر" onClick={e => this.removeRow(item.id)} className="fa fa-trash fa-fw close-grid-row"></span>}
												{item.stuffId != this.defaultGuid() && <span title="کپی سطر" onClick={e => this.copyRow(item.id)} className="fa fa-copy fa-fw close-grid-row"></span>}
											</td>}
										</tr>
									)}
								</tbody>
							</table>
							{this.state.type === 2 && <div className="row" style={{ "padding-left": "15px" }} >
								<div className="col-lg-9 col-md-12 col-sm-12">
								</div>
								<div className="col-lg-3 col-md-12 col-sm-12" style={{ "padding": "0" }} >
									<div className="row text-left">
										<div className="col-lg-6 title1" style={{ "padding": "0" }} >مجموع <span style={{ "font-weight": "normal" }} >({this.state.data.global.company.currencyUnit})</span></div>
										<div className="col-lg-6 text-center title1" style={{ "direction": "ltr" }} >{this.money(this.state.data.record.total)}</div>
									</div>
									<div className="row" style={{ "border-top": "1px solid rgb(69, 69, 69)", "margin-top": "1px", "margin-bottom": "10px" }} ></div>
								</div>
							</div>
							}
						</div>
						<div className="modal-footer">
							{this.state.data.record.status === 0 && <button type="button" className="hand btn btn-primary" onClick={e => this.save(e, 0)} >ذخیره</button>}
							{this.state.data.record.id !== this.defaultGuid() && this.state.data.record.status === 0 && <button type="button" className="hand btn btn-success" onClick={e => this.save(e, 1)}>صدور سند</button>}
							{this.state.data.record.id !== this.defaultGuid() && <a onClick={e => this.getPdf(this.state.data.record.id)} className="btn btn-primary"><span>PDF</span></a>}
							{this.state.data.record.id !== this.defaultGuid() && this.state.data.record.status === 1 && <a onClick={e => this.removeDocument()} className="btn btn-danger"><span>حذف سند</span></a>}
							<a className="btn btn-warning" onClick={e => this.closeMe()}>انصراف</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.getGlobalContainer(),
				this.renderForm(),
				this.renderPopupComponent()
			];

		return contents;
	}
}